export const NAME = 'campaignsList';

export const formDataFieldsMap = {
	campaignName: 'Název',
	campaignState: 'Stav kampaně',
	channel: 'Kanál',
};
